import * as Utils from '../editor/utils.js'

export class SpTabs {
  constructor(){
    this.restrict = 'EA';
    this.transclude = true;
    this.replace = true;
    this.template = `
      <div class="tabs">
        <ul class="tab-head">
          <li ng-repeat="pane in panes" ng-click="select(pane)" ng-class="{active:pane.selected}">
            {{pane.title}}
          </li>
        </ul>
        <div class="tab-content" ng-transclude></div>
      </div>
    `;
  }

  controller($scope, $element){
    var panes = $scope.panes = [];

    $scope.select = function(pane) {
      angular.forEach(panes, function(pane) {
        pane.selected = false;
      });
      pane.selected = true;
    }

    this.addPane = function(pane) {
      if (panes.length == 0 || pane.selected) $scope.select(pane);
      panes.push(pane);
    }

  }
}



export class SpTabPane {
  constructor(){
    this.restrict = 'EA';
    this.transclude = true;
    this.replace = true;
    this.require = '^sp-tabs';
    this.scope = {
      title: '@',
      selected: '@',
      id: '@'
    }
    this.template = `
      <div class="tab-pane" ng-class="{active: selected}" ng-transclude>
      </div>
    `;
  }

  link(scope, element, attrs, spTabsController){
    if(!scope.id){
      scope.id = scope.title;
    }
    spTabsController.addPane(scope);
  }
}

export class spCalender {
  constructor(config){
    this.restrict = 'EA';
    this.scope = {
      sessions: '=',
      user: '='
    }
    this.templateUrl = config.templateBasePath + 'directives/calender.html'
  }

  controller($scope, $state, $rootScope, config, ngDialog, gettextCatalog){
    $scope.today = moment()
    $scope.monthView = {}
    $scope.weekView = {}
    $scope.view = {}
    $scope.data = {}
    $scope.intensity = $rootScope.rview.Intensity
    // setting the view to month by default
    $scope.view.month = true
    $scope.view.week = false
    $scope.view.days = []
    $scope.view.showEvent = {}
    $scope.view.listView = false
    $scope.AgendaEmpty = false
    $scope.view.dateRangeView = false;

    $scope.agendaPageView = 0
    // console.log($scope.sessions);
    Object.defineProperty(Array.prototype, 'chunk_inefficient', {
        configurable: true,
        value: function(chunkSize) {
            var array=this;
            return [].concat.apply([],
                array.map(function(elem,i) {
                    return i%chunkSize ? [] : [array.slice(i,i+chunkSize)];
                })
            );
        }
    });

    // Assigning Start & end date for datepicker
    let iStartDate = moment().utc();
    let iEndtDate = moment().utc();
    $scope.data.startDate = (new Date(iStartDate.year(), iStartDate.month(), iStartDate.date())) +'';
    $scope.data.endDate = (new Date(iEndtDate.year(), iEndtDate.month(), iEndtDate.date())) +'';


    $scope.view.start_week = null
    $scope.view.end_week = null

    $scope.view.listWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    
    $scope.monthView.currentMonth = $scope.today.clone().startOf('month')
    $scope.monthView.previousMonth = $scope.monthView.currentMonth.clone().subtract(1, 'month').startOf('month')
    $scope.monthView.nextMonth = $scope.monthView.currentMonth.clone().add(1, 'month').startOf('month')

    $scope.weekView.currentWeek = $scope.today.clone().startOf('week')
    $scope.weekView.previousWeek = $scope.weekView.currentWeek.clone().subtract(1, 'week').startOf('week')
    $scope.weekView.nextWeek = $scope.weekView.currentWeek.clone().add(1, 'week').startOf('week')

    $scope.nxtMonth = function() {
      $scope.monthView.currentMonth = $scope.monthView.nextMonth.clone().startOf('month')
      $scope.monthView.previousMonth = $scope.monthView.currentMonth.clone().subtract(1, 'month').startOf('month')
      $scope.monthView.nextMonth = $scope.monthView.currentMonth.clone().add(1, 'month').startOf('month') 
    }

    $scope.prvMonth = function() {
      $scope.monthView.currentMonth = $scope.monthView.previousMonth.clone().startOf('month')
      $scope.monthView.previousMonth = $scope.monthView.currentMonth.clone().subtract(1, 'month').startOf('month')
      $scope.monthView.nextMonth = $scope.monthView.currentMonth.clone().add(1, 'month').startOf('month') 
    }

    $scope.nxtWeek = function() {
      $scope.weekView.currentWeek = $scope.weekView.nextWeek.clone().startOf('week')
      $scope.weekView.previousWeek = $scope.weekView.currentWeek.clone().subtract(1, 'week').startOf('week')
      $scope.weekView.nextWeek = $scope.weekView.currentWeek.clone().add(1, 'week').startOf('week') 
    }

    $scope.prvWeek = function() {
      $scope.weekView.currentWeek = $scope.weekView.previousWeek.clone().startOf('week')
      $scope.weekView.previousWeek = $scope.weekView.currentWeek.clone().subtract(1, 'week').startOf('week')
      $scope.weekView.nextWeek = $scope.weekView.currentWeek.clone().add(1, 'week').startOf('week') 
    }

    $scope.toggle = function(arg) {
      if(arg == 'month') {
        $scope.view.dateRangeView =false
        $scope.view.month = true
        $scope.view.week = false
        $scope.view.listmonth = true
        $scope.view.listweek = false
        $scope.view.dateRange = false
        $scope.buildAgendaPage()
      } else if(arg == 'date-range') {
        $scope.view.dateRange = true
        $scope.view.month = false
        $scope.view.week = false
        $scope.view.listweek = false
        $scope.view.listmonth = false
      } else {
        $scope.view.dateRangeView =false
        $scope.view.month = false
        $scope.view.dateRange = false
        $scope.view.week = true
        $scope.view.listweek = true
        $scope.view.listmonth = false
        $scope.buildAgendaPage()
      }
    }

    $scope.$watch('monthView.currentMonth', function(){
        $scope.view.days = getDaysArrayByMonth()

        let getFirstDay = $scope.view.days[0].whatDay
        let d = 0 
        for(let k in $scope.view.listWeek) {
          let emptyObj = {}
          emptyObj.hasValue = false
          if($scope.view.listWeek[k] == getFirstDay) {
            break;
          }
          emptyObj.id = "em"+d+"top"
          $scope.view.days.unshift(emptyObj)
          d++
        }
        
        let daysLength = $scope.view.days.length
        if(daysLength > 24 && daysLength <= 28){
          let sub = 28 - daysLength
          $scope.pushEmptyAtEnd(sub)
        }

        if(daysLength > 28 && daysLength <= 35){
          let sub = 35 - daysLength
          $scope.pushEmptyAtEnd(sub)
        } 

        if(daysLength > 35 && daysLength <= 42) {
          let sub = 42 - daysLength
          $scope.pushEmptyAtEnd(sub)
        }

        for(let m in $scope.view.days) {
          if($scope.view.days[m].moment) {
            if($scope.today.clone().format('D/M/YYYY') == $scope.view.days[m].moment.clone().format('D/M/YYYY')) {
              $scope.onDayEvent($scope.view.days[m])
              break;
            }            
          }
        }

        $scope.buildAgendaPage()
        // console.log(d,  $scope.view.listWeek.length, $scope.view.days.length)
    })

    

    $scope.$watch('weekView.currentWeek', function(){
        $scope.view.weekday = getWeekEvents()
        $scope.buildAgendaPage()
    })


    $scope.buildAgendaPage = function(){
      if($scope.view.listmonth) {
        let monthList = []
        for(let pv in $scope.view.days) {
          if($scope.view.days[pv].hasValue) {
            if($scope.view.days[pv].sessions.length != 0){
              for(let s in $scope.view.days[pv].sessions) {
                monthList.push($scope.view.days[pv].sessions[s])                  
              }
            }            
          }
        }          
        $scope.agendaPageView = monthList.chunk_inefficient(9)
      }

      if($scope.view.listweek) {
        let weekList = []
        for(let pv in $scope.view.weekday) {
          if($scope.view.weekday[pv].hasValue) {
            if($scope.view.weekday[pv].sessions.length != 0){
              for(let s in $scope.view.weekday[pv].sessions) {
                weekList.push($scope.view.weekday[pv].sessions[s])                  
              }
            }            
          }
        }          
        $scope.agendaPageView = weekList.chunk_inefficient(9)
      }

      if($scope.agendaPageView.length == 0) {
        $scope.AgendaEmpty = true
      } else {
        $scope.AgendaEmpty = false
      }
    }

    $scope.pushEmptyAtEnd = function(num) {
      let emptyObj = {}
      emptyObj.hasValue = false

      for(var i = 0; i < num; i++){
        emptyObj.id = "em"+i+"bottom"
        $scope.view.days.push(emptyObj)
      }
    }

    function getWeekEvents() {
      var weekStart = $scope.weekView.currentWeek.clone();
      var weekEnd = weekStart.clone().add('6', 'days')
      var difBtwDays = weekEnd.diff(weekStart, 'days')
      var arryDay = []

      $scope.view.start_week = weekStart
      $scope.view.end_week = weekEnd

      for(let d = 0; d <= difBtwDays; d++) {
        let dayEvent = {}
        var current = weekStart.clone().add(d, 'day');
        dayEvent.day = current.clone().format('D');
        dayEvent.whatDay = current.clone().format('dddd');
        dayEvent.month = current.clone().format('MMMM');
        dayEvent.moment = current.clone()
        dayEvent.sessions = []
        dayEvent.hasValue = true

        for(let k in $scope.sessions) {
          if(moment.utc($scope.sessions[k].date).utc().format('D/M/YYYY') == current.clone().format('D/M/YYYY')){
            $scope.sessions[k].tags = ($scope.sessions[k].tags) ? $scope.sessions[k].tags.replace(/[-]/g,' ') : '';
            dayEvent.sessions.push($scope.sessions[k])
          }
        }

        arryDay.push(dayEvent)
      }

      return arryDay;
    }

    function getDaysArrayByMonth() {
      var daysInMonth = $scope.monthView.currentMonth.clone().daysInMonth();
      var arrDays = [];

      for(let d = 1; d <= daysInMonth; d++) {
        let dayEvent = {}
        var current = $scope.monthView.currentMonth.date(d);

        dayEvent.day = current.clone().format('D');
        dayEvent.whatDay = current.clone().format('dddd');
        dayEvent.month = current.clone().format('MMMM');
        dayEvent.moment = current.clone()
        dayEvent.sessions = []
        dayEvent.hasValue = true
        
        if($scope.today.clone().format('D/M/YYYY') == current.clone().format('D/M/YYYY')) {
          dayEvent.isCurrentDay = true
        } else {
          dayEvent.isCurrentDay = false
        }

        for(let k in $scope.sessions) {
          if(moment.utc($scope.sessions[k].date).utc().format('D/M/YYYY') == current.clone().format('D/M/YYYY')){
            // .tags.replace(/[-]/g,' ');
            // $scope.sessions[k].tags = $scope.sessions[k].tags.replace(/[-]/g,' ')
            $scope.sessions[k].tags = ($scope.sessions[k].tags) ? $scope.sessions[k].tags.replace(/[-]/g,' ') : '';
            dayEvent.sessions.push($scope.sessions[k])
          }
        }
        arrDays.push(dayEvent);
      }

      return arrDays;
    }

    $scope.goto = function(session){
      $state.go('app.session', {sessionkey:session.key});
    }

    $scope.onDayEvent = function(evnts) {
      $scope.view.showEvent = evnts
    }

    $scope.view.listmonth = false
    $scope.view.listweek = false

    $scope.listView = function(view, event) {
      $scope.view.dateRangeView = false;
      if(view == 'list') {
        $scope.view.listView = true        
        $scope.buildAgendaPage()
      } else {
        $scope.view.listView = false
      }

      if($scope.view.listView) {
        if($scope.view.month) {
          $scope.view.listmonth = true
          $scope.buildAgendaPage()
        } else {
          $scope.view.listmonth = false
        }

        if($scope.view.week) {
          $scope.view.listweek = true
          $scope.buildAgendaPage()
        } else {
          $scope.view.listweek = false
        }
      }
    }

    $scope.showDateRangeSessions = function() {
      $scope.view.dateRangeView = true;
      $scope.data.dateRangeView = []
      $scope.view.categoryObj = {}
      $scope.view.categoryList = []
      let tmpDateRangeView = []
      let tmpDate = {}
      let startDate = angular.copy($scope.data.startDate)
      let endDate = angular.copy($scope.data.endDate)
      tmpDate.startDate = moment(startDate)
      tmpDate.endDate = moment(endDate)
      
      var start = moment(tmpDate.startDate.clone(), 'MM-DD-YYYY');
      var end = moment(tmpDate.endDate.clone(), 'MM-DD-YYYY');
      var diff = end.diff(start, 'days'); 


      if(Math.sign(diff) == 0) {
          for(let k in $scope.sessions) {
            if($scope.sessions[k].date) {
              if(moment.utc($scope.sessions[k].date).utc().format('D/M/YYYY') == tmpDate.startDate.clone().format('D/M/YYYY')) {
                tmpDateRangeView.push($scope.sessions[k])
                if($scope.sessions[k].tags){
                  var tags = $scope.sessions[k].tags.split(',')
                  for (var i = 0; i < tags.length; i++) {
                    let tag = tags[i].trim().toString()
                    $scope.view.categoryList.push(tag)
                  }
                }
              }
            }
          }
          $scope.data.dateRangeView = tmpDateRangeView.chunk_inefficient(9)
          $scope.view.categoryList = $scope.view.categoryList.filter(v=>v!='');
          
      } else if (Math.sign(diff) != -1) {
          for(let i = 0; i < diff+1; i++) {
           var new_date = moment(tmpDate.startDate, "DD-MM-YYYY").add(i, 'days');
           for(let k in $scope.sessions) {
              if($scope.sessions[k].date) {
                if(moment.utc($scope.sessions[k].date).utc().format('D/M/YYYY') == new_date.clone().format('D/M/YYYY')) {
                  tmpDateRangeView.push($scope.sessions[k])
                  if($scope.sessions[k].tags){
                    var tags = $scope.sessions[k].tags.split(',')
                    
                    for (var l = 0; l < tags.length; l++) {
                      let tag = tags[l].trim().toString()
                     
                      $scope.view.categoryList.push(tag)
                    }
                  }
                }
              }
            }
          }
          $scope.data.dateRangeView = tmpDateRangeView.chunk_inefficient(9)
          $scope.view.categoryList = $scope.view.categoryList.filter(v=>v!='');
      } else {
        console.log("End date should be greater that start date")
      }

      if($scope.view.categoryList.length) {
        $scope.view.categoryList.forEach(function(i) { $scope.view.categoryObj[i] = ($scope.view.categoryObj[i]||0)+1;  });
      }

      // console.log($scope.view.categoryObj, $scope.view.categoryList)
    }
  }
}

export class SpSessions {
  constructor(config){
    this.restrict = 'EA';
    this.scope = {
      sessions: '=',
      activeSessionKey: '=?bind',
      activeSort: '=?bind',
      mode: '@',
      onSessionSelected: '&',
      drillKey:'='
    }
    this.templateUrl = config.templateBasePath + 'directives/sessions.html'
  }

  controller($scope, $state, $rootScope, config, ngDialog, gettextCatalog){
    $scope.isDemo = $rootScope.user.isDemo;
    $scope.actions = [
      {text:gettextCatalog.getString('Edit'), value:'edit'},
      {text:gettextCatalog.getString('Delete'), value:'delete'},
    ];

    $scope.activeSort = {
      name: 'name',
      rev: false
    };

    $scope.loadingAction = false;
    $scope.onItemClick = ($event, session) =>{
      if($scope.mode != 'chooser'){
        return;
      }

      $scope.activeSessionKey = session.key;
      var q = $scope.onSessionSelected({
        session:session
      });

      if(q.then){
        $scope.loadingAction = true;
        q.then(()=>{$scope.loadingAction = false;})
      }
    }

    $scope.doAction = (selected, session, index) => {
      if(selected.value == 'edit'){
        $state.go('app.session', {sessionkey:session.key});
      }else if(selected.value == 'delete'){
        var deleteTitleText = gettextCatalog.getString('Are you sure you want to delete?');
        var cancelText = gettextCatalog.getString('Cancel');
        var deleteText = gettextCatalog.getString('Delete');

        ngDialog.open({
          template:`
              <br/>
              <p>${deleteTitleText}</p>
              <br/>
              <div class="ngdialog-buttons">
                  <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">${cancelText}</button>
                  <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirmDelete(1)">${deleteText}</button>
              </div>`,
          plain: true,
          showClose: false,
          scope: $scope,
          controller: function($scope){
            $scope.confirmDelete = function(confirm){
              $scope.loadingAction = true;
              let delSesionKey = session.key;
              config.dataProvider.deleteSession(session).then(()=>{
                $scope.loadingAction = false;
                let i = 0;
                for(let key in $scope.sessions) {
                  if($scope.sessions[key].key == delSesionKey) {
                    // console.log(index, i, $scope.sessions[key].key+" == "+delSesionKey)
                    $scope.sessions.splice(i, 1);
                    break;                    
                  }
                  i++;
                }
              })
              $scope.closeThisDialog(0);
            }
          }
        });


      }
    }

    $scope.newSession = function(){
      var passValue = {};
      if($scope.drillKey){
        passValue.drillkey = $scope.drillKey;
      }
      $state.go('app.session', {sessionkey:'new', passValue});
    }

    $scope.selectedAction = {};
  }

}

export class SpDrills {
  constructor(config){
    this.restrict = 'EA';
    this.scope = {
      drills: '=',
      addedDrills: '=',
      sessionKey: '=',
      activeDrillKey: '=?bind',
      activeSort: '=?bind',
      mode: '@',
      onDrillSelected: '&',
      onDrillsAdd: '&'
    }
    this.templateUrl = config.templateBasePath + 'directives/drills.html'
  }

  controller($scope, $state, $rootScope,config, gettextCatalog, ngDialog){

    $scope.post = {
      started: false,
      error: null
    };

    $scope.activeSort = {
      name: 'name',
      rev: false
    };

    $scope.ts = moment().unix();
    $scope.isDemo = $rootScope.user.isDemo;
    $scope.actions = [
      {text:gettextCatalog.getString('Print'), value:'view'},
      {text:gettextCatalog.getString('Editor'), value:'edit'},
      {text:gettextCatalog.getString('Share'), value:'share'},
      {text:gettextCatalog.getString('Copy'), value:'copy'},
      {text:gettextCatalog.getString('Add to Session'), value:'tosession'},
      {text:gettextCatalog.getString('Delete'), value:'delete'},
    ];
    $scope.loadingAction = false;

    $scope.addDrills = ()=>{
      $scope.post.started = true;
      var q = $scope.onDrillsAdd();

      if(q.then){
        $scope.post.started = false;
        $scope.loadingAction = true;
        q.then(()=>{$scope.loadingAction = false;})
      }
    }

    $scope.onSelect = (drill)=>{
      if($scope.mode == 'chooser'){
        return;
      }
      $state.go('app.drilleditor', {drillkey:drill.key});
    }

    $scope.onItemClick = ($event, drill) =>{
      if($scope.mode != 'chooser'){
        return;
      }

      if(drill.selected){
        drill.selected = false;
        $scope.activeDrillKey = null;
        $scope.addedDrills.splice($scope.addedDrills.indexOf(drill.key), 1);
      }
      else{
        drill.selected = true;
        $scope.activeDrillKey = drill.key;
        $scope.addedDrills.push(drill.key)
      }
    }

    $scope.doAction = (selected, drill, index) => {
      if(selected.value == 'edit'){
        $state.go('app.drilleditor', {drillkey:drill.key});
      }else if(selected.value == 'delete'){
        var deleteTitleText = gettextCatalog.getString('Are you sure you want to delete?');
        var cancelText = gettextCatalog.getString('Cancel');
        var deleteText = gettextCatalog.getString('Delete');

        ngDialog.open({
          template:`
              <br/>
              <p>${deleteTitleText}</p>
              <br/>
              <div class="ngdialog-buttons">
                  <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">${cancelText}</button>
                  <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirmDelete(1)">${deleteText}</button>
              </div>`,
          plain: true,
          showClose: false,
          scope: $scope,
          controller: function($scope){
            $scope.confirmDelete = function(confirm){
              $scope.loadingAction = true;
              let delDrillKey = drill.key;
              config.dataProvider.deleteDrill(drill.sessionkey, drill).then(()=>{
                $scope.loadingAction = false;
                // $scope.drills.splice(index, 1);
                let i = 0;
                for(let key in $scope.drills) {
                  if($scope.drills[key].key == delDrillKey) {
                    // console.log(index, i, $scope.sessions[key].key+" == "+delSesionKey)
                    $scope.drills.splice(i, 1);
                    break;                    
                  }
                  i++;
                }
              })
              $scope.closeThisDialog(0);
            }
          }
        });

      }else if (selected.value == 'tosession') {
        $state.go('app.chooser', {sessionkey:drill.sessionkey, drillkey:drill.key,
        mode:'session',
        callback:'home'});
      }else if (selected.value == 'share') {
        ngDialog.open({
          template: config.templateBasePath + 'share.html',
          showClose: true,
          controller($scope, $window) {
            $scope.showSessionShare = false;
            $scope.shareUrl = $state.href('app.drillshare',
            {drillkey:drill.key, sharekey:drill.shareToken},
            {absolute:true});
          }
        })
      }else if(selected.value == 'view'){
        $state.go('app.drillprint', {'drillkey': drill.key});
      }
      else if(selected.value == 'copy'){
        config.dataProvider.copyDrill(drill.key).then((data)=>{
          if(data.data.ok){
            $scope.drills.push(data.data.drill);
          }
        }, (err)=>{
            //console.log('Error in copying drill', err)
        });

      }
    }

    $scope.selectedAction = {};

    $scope.newDrill = function(){
      var passValue = {};
      if($scope.sessionKey){
        passValue.sessionkey = $scope.sessionKey;
      }
      $state.go('app.drilleditor', {drillkey:'new', passValue});
    }

    $scope.editdrill = function(drill, indx) {
      $scope.editMode = true;
      $scope.activeDrillKey = drill.drillkey;
      $scope.activeDrillIndex = drill.orderIndex;
      $scope.activeIndex = indx;
    }

    $scope.updateDrill = (drill)=>{
      $scope.post.started = true;
      var postData = {
        key: drill.key,
        name: drill.name,
        setupText: drill.setupText,
        instructText: drill.instructText,
        coachText: drill.coachText,
        pitch: drill.pitch,
        duration: drill.duration,
      };

      config.dataProvider.saveDrill(postData).then((data)=>{
        $scope.editMode = false;
        $scope.post.started = false;
      }, (err)=>{
      });
    }

  }
}


export class SpSessionDrills {
  constructor(config){
    this.restrict = 'EA';
    this.scope = {
      drills: '=',
      sessionKey: '=',
      activeDrillKey: '=?bind',
      activeDrillIndex: '=?bind',
      activeSort: '=?bind',
      isPrintView: '=',
      mode: '@',
      isShareMode: '=',
      showList:'=',
      onDrillSelected: '&',
      showBlack:"=",
    }
    this.templateUrl = config.templateBasePath + 'directives/sessiondrills.html'
  }

  controller($scope, $state, config, gettextCatalog, ngDialog){

    if($scope.isShareMode) {
      $scope.drillSelect = "drillprint";
    }
    else {
      $scope.drillSelect = "drilleditor";
    }

    // $scope.activeSort = {
    //   name: 'drill.orderIndex',
    //   rev: false
    // };

    for(let dr in $scope.drills) {
      if($scope.drills[dr].order) {
        $scope.drills[dr].orderIndex = $scope.drills[dr].order;        
      } 
    }

    // $scope.orderreverse = function(val) {
    //   if(val == 'asc') {
    //     for (var i = 0; i < $scope.drills.length; i++) {
    //       console.log($scope.drills[i].order)
    //     };
    //   }

    //   if(val == 'dec') {
    //     for (var i = 0; i < $scope.drills.length; i++) {
    //       console.log($scope.drills[i].order)
    //     };   
    //   }
    // }


    $scope.ts = moment().unix();
    $scope.actions = [
      {text:gettextCatalog.getString('Print'), value:'view'},
      {text:gettextCatalog.getString('Edit'), value:'edit'},
      {text:gettextCatalog.getString('Share'), value:'share'},
      {text:gettextCatalog.getString('Copy'), value:'copy'},
      {text:gettextCatalog.getString('Remove from session'), value:'remove'},

    ];
    $scope.loadingAction = false;
    $scope.editMode = false;

    $scope.post = {
      started: false,
      error: null
    };

    $scope.onDrillMved = function(val, changedIdx) {
      if($scope.isShareMode){
        return;
      }
      for (var i = 0; i < val.length; i++) {
        // console.log(val[i].orderIndex, val.length, changedIdx);
        val[i].orderIndex = i + 1;
        // console.log(val[i].orderIndex, val);
        $scope.updateDrillOnChg(val[i]);
      };
    }



    $scope.onItemClick = ($event, drill) =>{
    }

    $scope.doAction = (selected, drill, index) => {
      $scope.activeDrillKey = drill.drillkey;
      if(selected.value == 'edit'){
        var passValue = {
          sessionkey: $scope.sessionKey
        }
        $state.go('app.drilleditor', {'drillkey' : drill.drill.key, passValue});
      }else if(selected.value == 'remove'){
        var deleteTitleText = gettextCatalog.getString('Are you sure you want to remove this drill from the session?');
        var cancelText = gettextCatalog.getString('Cancel');
        var deleteText = gettextCatalog.getString('Remove');

        ngDialog.open({
          template:`
              <br/>
              <p>${deleteTitleText}</p>
              <br/>
              <div class="ngdialog-buttons">
                  <button type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">${cancelText}</button>
                  <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirmDelete(1)">${deleteText}</button>
              </div>`,
          plain: true,
          showClose: false,
          scope: $scope,
          controller: function($scope){
            $scope.confirmDelete = function(confirm){
              $scope.loadingAction = true;
              drill.key = drill.drillkey;
              config.dataProvider.deleteDrill(drill.sessionkey, drill).then(()=>{
                $scope.loadingAction = false;
                $scope.drills.splice(index, 1);
              })
              $scope.closeThisDialog(0);
            }
          }
        });

      }else if (selected.value == 'tosession') {
        $state.go('app.chooser', {sessionkey:drill.sessionkey, drillkey:drill.key,
        mode:'session',
        callback:'app.library'});
      }else if (selected.value == 'share') {
        ngDialog.open({
          template: config.templateBasePath + 'share.html',
          showClose: true,
          controller($scope, $window) {
            $scope.showSessionShare = false;
            $scope.shareUrl = $state.href('app.drillshare',
            {drillkey:drill.drill.key, sharekey:drill.drill.shareToken},
            {absolute:true});
          }
        })
      }else if (selected.value == 'view') {
        $state.go('app.drillprint', {'drillkey': drill.drill.key});
      }
      else if(selected.value == 'copy'){
        config.dataProvider.copyDrill(drill.drill.key).then((data)=>{
          if(data.data.ok){
            config.dataProvider.attachDrill(drill.sessionkey, data.data.drill.key).then(()=>{
              var newDrill = data.data.drill;
              var drillParams = {
                key: newDrill.key,
                drillKey: newDrill.key,
                name: newDrill.name,
                setupText: newDrill.setupText,
                coachText: newDrill.coachText,
                instructText: newDrill.instructText,

                orderIndex: drill.orderIndex,
                pitch: drill.pitch,
                duration: drill.duration,
              }
              config.dataProvider.saveSessionDrill(drill.sessionkey, drillParams).then(()=>{
                $scope.post = false;
                var newSessionDrill = angular.copy(drill);
                newSessionDrill.drill = newDrill;
                $scope.drills.push(newSessionDrill);
                // console.log("Session Drill Saved");
              })

              resolve();
            }, ()=>{
              reject();
            })
          }
        }, (err)=>{
            //console.log('Error in copying drill', err)
        });

      }
    }

    $scope.newDrill = function(){
      var passValue = {
        sessionkey: $scope.sessionKey
      }
      $state.go('app.drilleditor', {drillkey:'new', passValue});
    }

    $scope.drillEdit = function (drill) {
      if(!$scope.isShareMode){
        var passValue = {
          sessionkey: $scope.sessionKey
        }
        $state.go('app.drilleditor', {'drillkey' : drill.drill.key, passValue});
      }
    }

    $scope.editsessiondrill = function(drill, indx) {
      $scope.editMode = true;
      $scope.activeDrillKey = drill.drillkey;
      $scope.activeDrillIndex = drill.orderIndex;
      $scope.activeIndex = indx;
    }

    $scope.updateDrillOnChg = function(drill) {
      var drillParams = {
        key: drill.drillkey,
        drillKey: drill.drillkey,
        name: drill.drill.name,
        setupText: drill.drill.setupText,
        coachText: drill.drill.coachText,
        instructText: drill.drill.instructText,

        orderIndex: drill.orderIndex,
        pitch: drill.pitch,
        duration: drill.duration,
      }
      config.dataProvider.saveSessionDrill(drill.sessionkey, drillParams).then(()=>{
        $scope.post = false;
        // console.log("Session Drill Saved");
      })
    }

    $scope.updateAlSessionDrills = function(){

      for (var i = 0; i < $scope.drills.length; i++) {
        var drill = $scope.drills[i];
        $scope.updateDrillOnChg(drill);
      };
    }

    $scope.updateSessiondrill = function(drill, indx) {
      $scope.post = true;

      $scope.editMode = false;
      $scope.activeDrillKey = drill.drillkey;
      $scope.activeDrillIndex = drill.orderIndex;
      $scope.activeIndex = null;
      var tmpDrills = $scope.drills;

      // console.log(indx, drillParams.orderIndex, drill, tmpDrills);
      var tmpDrillDate = tmpDrills[indx];
      tmpDrills.splice(indx, 1);
      tmpDrills.splice(drill.orderIndex-1, 0, tmpDrillDate);
      for (var i = 0; i < tmpDrills.length; i++) {
        tmpDrills[i].orderIndex = i + 1;
      };
      $scope.updateAlSessionDrills();
    }

    $scope.selectedAction = {};
  }
}


function Draggable() {
  return function(scope, element, attrs) {
    // this gives us the native JS object
    var el = element[0];

    el.draggable = true;

    el.addEventListener(
      'dragstart',
      function(e) {
        Utils.fixEventObject(e, this);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('_sp_offsetX', e._sp_offsetX);
        e.dataTransfer.setData('_sp_offsetY', e._sp_offsetY);
        e.dataTransfer.setData('ref', attrs.spData);
        this.classList.add('drag');
        return false;
      },
      false
    );

    el.addEventListener(
      'dragend',
      function(e) {
        this.classList.remove('drag');
        return false;
      },
      false
    );
  }
}

function Droppable() {
  return {
    scope: {
      drop: '&',
      bin: '='
    },
    link: function(scope, element) {
      // again we need the native object
      var el = element[0];

      el.addEventListener(
        'dragover',
        function(e) {
          e.dataTransfer.dropEffect = 'move';
          // allows us to drop
          if (e.preventDefault) e.preventDefault();
          this.classList.add('over');
          return false;
        },
        false
      );

      el.addEventListener(
        'dragenter',
        function(e) {
          this.classList.add('over');
          return false;
        },
        false
      );

      el.addEventListener(
        'dragleave',
        function(e) {
          this.classList.remove('over');
          return false;
        },
        false
      );

      el.addEventListener(
        'drop',
        function(e) {
          // Stops some browsers from redirecting.
          if (e.stopPropagation) e.stopPropagation();
          if (e.preventDefault) e.preventDefault();

          this.classList.remove('over');

          var ref = e.dataTransfer.getData('ref');
          // var binId = this.id;
          //
          // var item = document.getElementById(e.dataTransfer.getData('ref'));
          // this.appendChild(item);

          // call the passed drop function
          scope.$apply(function(scope) {
            var fn = scope.drop();
            if ('undefined' !== typeof fn) {
              fn(ref, e,
                e.dataTransfer.getData('_sp_offsetX'),
                e.dataTransfer.getData('_sp_offsetY'));
            }
          });

          return false;
        },
        false
      );
    }
  }
}

export var Draggable;
export var Droppable;
